import { all } from 'redux-saga/effects';
import { AuthSaga } from './authentication/auth.sagas';
import { KycSaga } from './kyc/kyc.sagas';
import { MemberSaga } from './member/member.sagas';
import { PlanSaga } from './plan/plan.sagas';
import { SettingSaga } from './setting/setting.sagas';
import { TransactionSaga } from './transaction/transaction.sagas';
import { UserSaga } from './user/user.sagas';

export default function* rootSaga() {
    yield all([
        AuthSaga(),
        UserSaga(),
        TransactionSaga(),
        PlanSaga(),
        MemberSaga(),
        UserSaga(),
        SettingSaga(),
        KycSaga()
    ]);
}